<template>
  <router-link
    :to="{ name, params, query }"
    v-bind="{ exact, tag, activeClass, exactActiveClass }">
    <slot />
  </router-link>
</template>

<script>
export default {

  props: {
    name: String,

    params: {
      type: Object,
      default: () => {}
    },

    query: {
      type: Object,
      default: () => {}
    },

    exact: {
      type: Boolean,
      default: false
    },

    tag: {
      type: String,
      default: 'a',
    },

    activeClass: [Array, Object, String],
    exactActiveClass: [Array, Object, String],
  }

}
</script>
